import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-ag-range-area-series-options',
	templateUrl:'./AgRangeAreaSeriesPluginCompPage.html',
	styles: [],
	styleUrls:['./AgRangeAreaSeriesPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class AgRangeAreaSeriesPluginCompPage
{
	mdContent_752 = `\`\`\`java
import com.jwebmp.plugins.agchartsenterprise.options.series.AgRangeAreaSeriesOptions;
\`\`\``;
}
